import Config from 'react-native-config';

import {
  FETCH_MULE_AUTH_TOKEN,
  FETCH_MULE_REVOKE_TOKEN,
  FETCH_SFMC_CONTACT_KEY,
  REQUEST_POST,
} from '/enum/request.enum';
import {createStorage} from '/util/async-storage';
import {getErrorTrackingUtilDefaultInstance} from '/util/error-tracking/error-tracking.util';
import {setAccessTokenMule, setMuleRefreshToken} from '/util/fetch.util';
import {getSfmcInstance} from '/util/sfmc/sfmc.util';

import {request} from '../api/request';

export const GET_SFMC_DATA: string = 'SFMC/GET_SFMC_DATA';
const muleHeaderContentType: string = 'application/json';
const muleHeaderAuthToken = Config.MULE_HEADER_AUTH_TOKEN;
export const {
  getValue: getSfmcUserData,
  setValue: setSfmcUserData,
  clearValue: clearSfmcUserData,
} = createStorage({
  key: 'sfmc-data',
  defaultValue: null,
});
const {
  getValue: getMuleTokenFromStorage,
  setValue: setMuleTokenFromStorage,
  clearValue: clearMuleToken,
} = createStorage({
  key: 'mule-token',
  defaultValue: null,
});

export const getStorageMuleToken = async (): Promise<string | null> => {
  try {
    const token = await getMuleTokenFromStorage();
    if (token === null) {
    }
    return token; // Return the token, it can be null if not found
  } catch (error) {
    return null; // Handle the error case
  }
};
export const setStorageMuleToken = async (newToken: string) => {
  try {
    const existingToken = await getMuleTokenFromStorage();
    // If there is an existing token, clear it
    if (existingToken) {
      await clearMuleToken();
    }
    await setMuleTokenFromStorage(newToken);
  } catch (error) {}
};
export const getSfmcUserDataFromStorage = async () => {
  return await getSfmcUserData();
};
export const saveSfmcUserDataToStorage = (data: any) => {
  setSfmcUserData(data);
};
const headers = {
  'Content-Type': muleHeaderContentType,
  Authorization: muleHeaderAuthToken,
};
export const getMuleToken = async (username: any, password: any) => {
  try {
    const res = await request(FETCH_MULE_AUTH_TOKEN, {
      method: REQUEST_POST,
      body: {
        userName: username,
        password: password,
      },
      muleHeaders: headers,
      isMuleApi: true,
    });
    if (res) {
      // @ts-expect-error TS(2339): Property 'oktaToken' does not exist on type '{ dat... Remove this comment to see the full error message
      const {oktaToken, refreshToken, expiresIn} = res;
      setMuleRefreshToken('com.yourApp.refreshMuleToken', refreshToken);
      setAccessTokenMule(oktaToken, expiresIn);
      return oktaToken;
    }
  } catch (err) {
    getErrorTrackingUtilDefaultInstance().trackError(err, 'getMuleToken api');
  }
};
export const getSfmcContactKey = async (inputPayload: any) => {
  const {username, password} = inputPayload;
  const userDataFromStorage = await getSfmcUserDataFromStorage();
  // this check is to call the mule api only when the contactkey is not there in the storage for the user
  try {
    const token = await getMuleToken(username, password);
    if (token) {
      await setStorageMuleToken(token);
      if (
        !userDataFromStorage ||
        (userDataFromStorage &&
          userDataFromStorage.length > 0 &&
          ![...userDataFromStorage]?.some(obj => obj.hasOwnProperty(username)))
      ) {
        const res = await request(FETCH_SFMC_CONTACT_KEY, {
          body: {access_token: token},
          muleHeaders: headers,
          isMuleApi: true,
        });
        if (res) {
          // @ts-expect-error TS(2339): Property 'crmContactId' does not exist on type '{ ... Remove this comment to see the full error message
          const {crmContactId} = res;
          if (crmContactId) {
            const userData = {
              [username]: crmContactId,
            };
            if (!userDataFromStorage) {
              saveSfmcUserDataToStorage([userData]);
            } else {
              saveSfmcUserDataToStorage([...userDataFromStorage, userData]);
            }
            getSfmcInstance().setContactKey(crmContactId);
          }
        }
      }
    } else if (
      userDataFromStorage &&
      userDataFromStorage.length > 0 &&
      [...userDataFromStorage]?.some(obj => obj.hasOwnProperty(username))
    ) {
      userDataFromStorage.forEach((obj: any) => {
        Object.keys(obj).forEach(user => {
          if (user === username) {
            getSfmcInstance().setContactKey(obj[user]);
          }
        });
      });
    }
  } catch (err) {
    getErrorTrackingUtilDefaultInstance().trackError(err, 'getSfmcContactKey');
  }
};
export const revokeMuleToken = async () => {
  const muleAuthToken = await getStorageMuleToken();
  try {
    const res =
      muleAuthToken &&
      (await request(FETCH_MULE_REVOKE_TOKEN, {
        method: REQUEST_POST,
        body: {accessToken: muleAuthToken},
        muleHeaders: headers,
        isMuleApi: true,
        params: {access_token: muleAuthToken},
      }));
    if (res && muleAuthToken) {
      clearMuleToken();
    }
  } catch (err) {
    getErrorTrackingUtilDefaultInstance().trackError(
      err,
      'revokeMuleToken api',
    );
  }
};
